<section class="certificate"
  [class.is_horisontal]="award.certificate.preview?.is_horisontal">
  <span class="certificate__card">
    <span *ngIf="award.count_cards > 1" class="certificate__card__count">
      <!-- {{ award.count_cards }} -->
      {{ award.id }}
    </span>
    <img src="{{ award.certificate.preview?.url }}" alt="{{ award.certificate.title }}">
  </span>
  <span class="certificate__info">
    <span class="certificate__title">
      {{ award.certificate.title }}
    </span>
    <span *ngIf="award.for_what" class="certificate__for_what">
      {{ award.for_what | wordSlice:4 }}
    </span>
    <span class="certificate__date">
      {{ award.date | date }}
    </span>
  </span>
</section>
